export default "__VITE_ASSET__DCeEyaLc__"